import "./index.css";

import { queryClient } from "@/lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { CalculatorProvider } from "@/context/CalculatorContext";
import { ThemeProvider } from "@/context/ThemeContext";

export default function LayoutDefault({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <CalculatorProvider>
          {children}
        </CalculatorProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}